import { Link } from "react-router-dom";
import { ImageWithFallback } from "./ImageWithFallback";

const TRUST_BULLETS = [
  "No credit card required",
  "Live in under 10 minutes",
  "Free forever tier available",
];

export function LandingBusinessCTA() {
  return (
    <section id="for-business" className="lp-py-16 lp-px-6 lp-relative">
      <div className="lp-max-6xl lp-mx-auto">
        <div className="lp-glass-card lp-r-3xl lp-p-10 md-p-16 lp-relative lp-overflow-hidden">
          
          {/* Subtle background glow highlights */}
          <div
            aria-hidden
            className="lp-absolute lp-top-0 lp-right-0 lp-w-80 lp-h-80 lp-r-full lp-op-15 lp-pointer-none lp-tx-30-neg30"
            style={{ background: "radial-gradient(circle, rgba(74, 158, 255, 0.2) 0%, transparent 70%)" }}
          />
          <div
            aria-hidden
            className="lp-absolute lp-bottom-0 lp-left-0 lp-w-64 lp-h-64 lp-r-full lp-op-08 lp-pointer-none lp-tx-neg30-30"
            style={{ background: "radial-gradient(circle, rgba(74, 158, 255, 0.1) 0%, transparent 70%)" }}
          />

          <div className="lp-relative lp-z-10 lp-grid lp-grid-cols-1 md-cols-2 lp-gap-12 lp-items-center">
            
            {/* Left Column: Business Content Text */}
            <div>
              <p
                className="lp-text-blue lp-text-xs lp-uppercase lp-tracking-wide lp-mb-4"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                For Restaurants, Cafés & Venues
              </p>
              <h2
                className="lp-text-dark lp-mb-6"
                style={{
                  fontFamily: "'Fraunces', serif",
                  fontWeight: 600,
                  letterSpacing: "-0.025em",
                  fontSize: "clamp(1.8rem, 4vw, 3rem)",
                  lineHeight: 1.1,
                }}
              >
                Own a venue in the UAE?
                <br />
                <span className="lp-text-blue" style={{ fontStyle: "italic" }}>Get found.</span>
              </h2>
              
              <div
                className="lp-text-muted lp-mb-8 lp-leading-relaxed lp-flex lp-flex-col lp-gap-4"
                style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, fontSize: "1.05rem" }}
              >
                <p>
                  If you own a café, restaurant, lounge, or bar, Hubscroll helps your venue get discovered by thousands of people searching for their next destination.
                </p>
                <p>
                  Businesses can create a professional venue profile, upload photos, and manage their listing through a simple dashboard.
                </p>
                <p>
                  Once listed, your venue becomes visible to users exploring the Hubscroll mobile app.
                </p>
              </div>

              {/* Business Action Buttons */}
              <div className="lp-flex lp-flex-wrap lp-gap-4">
                <Link
                  to="/sign-up"
                  className="lp-px-7 lp-py-3 lp-r-full lp-bg-blue lp-text-white lp-transition lp-hov-bg-blue-lt lp-font-medium lp-text-center"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  Create Your Venue Listing
                </Link>
                <Link
                  to="/sign-in"
                  className="lp-px-7 lp-py-3 lp-r-full lp-border lp-bc-b15 lp-text-dark lp-transition lp-hov-scale lp-text-center"
                  style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400 }}
                >
                  See how it works
                </Link>
              </div>

              {/* Trust bullets underneath */}
              <div className="lp-mt-8 lp-flex lp-flex-wrap lp-gap-6">
                {TRUST_BULLETS.map((t) => (
                  <div key={t} className="lp-flex lp-items-center lp-gap-2">
                    <div className="lp-w-1 lp-h-1 lp-r-full lp-bg-blue" />
                    <span className="lp-text-xs lp-text-muted" style={{ fontFamily: "'Outfit', sans-serif" }}>
                      {t}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: Mobile App Screenshot */}
            <div className="lp-flex lp-justify-center">
              <img
                src="/assets/images/mobile-app-hubscrolls.png"
                alt="Hubscroll mobile app venue mockup screen"
                style={{ maxWidth: "320px", width: "100%", display: "block" }}
              />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
